import { render } from "./Start.vue?vue&type=template&id=61946fee&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=61946fee&lang=scss&scoped=true"
import "./Start.vue?vue&type=style&index=1&id=61946fee&lang=scss"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61946fee"]])

export default __exports__